export const EDUCATION_HUB_CONTENT_MAX_WIDTH = "900px";
